__turbopack_context__.v({
  "--flow": "photo-gallery-top-bar-module-scss-module__xIpVOq__--flow",
  "--flow-masonry": "photo-gallery-top-bar-module-scss-module__xIpVOq__--flow-masonry",
  "--scroll": "photo-gallery-top-bar-module-scss-module__xIpVOq__--scroll",
  "__title": "photo-gallery-top-bar-module-scss-module__xIpVOq____title",
  "mobile-hidden": "photo-gallery-top-bar-module-scss-module__xIpVOq__mobile-hidden",
  "photo-gallery-top-bar": "photo-gallery-top-bar-module-scss-module__xIpVOq__photo-gallery-top-bar",
});
